import { useTranslation } from 'react-i18next';
import { StandardModal } from '@/components/molecules/common/Modal';
import { Typography } from '@mui/material';
import styles from '../Modal.module.scss';

interface ShippedInTimeModalProps {
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
  productId: number;
  error?: string;
}

const ShippedInTimeModal = ({ onClose, onSubmit, isLoading, productId, error }: ShippedInTimeModalProps) => {
  const { t } = useTranslation();

  return (
    <StandardModal
      title={t('modal.client_badges.product_details.shipped_in_time.title')}
      onClose={onClose}
      onSubmit={onSubmit}
      submitLabel={t('common.submit')}
      submittable={!isLoading}
      body={
        <div className={styles.clientBadges_removeCancelContent}>
          <span>{`${t('modal.client_badges.product_details.shipped_in_time.item')} #${productId}`}</span>

          <div
            dangerouslySetInnerHTML={{
              __html: t('modal.client_badges.product_details.shipped_in_time.description'),
            }}
          />

          {!!error && (
            <Typography
              color="error"
              variant="body2"
            >
              {error}
            </Typography>
          )}
        </div>
      }
      containerStyle={{ maxWidth: 500 }}
      modalName="shipped-in-time-modal"
    />
  );
};

export default ShippedInTimeModal;
